import React from 'react';
import { formatMessage } from 'umi-plugin-react/locale';
import Link from 'umi/link';
import Exception from '@/components/Exception';

const Exception403 = () => (
  <Exception
    type="403"
    desc={formatMessage({ id: 'exception.description.403' })}
    linkElement={Link}
    backText={formatMessage({ id: 'exception.back' })}
  />
);

export default Exception403;
